import type { JsonValue, NodeId } from "./workflowTypes";

export interface AssertionResult {
  readonly name: string;
  readonly score: number;
  readonly passThreshold?: number;
  readonly errored?: true;
  readonly expected?: JsonValue;
  readonly actual?: JsonValue;
  readonly message?: string;
  readonly details?: Readonly<Record<string, JsonValue>>;
}

export const DEFAULT_ASSERTION_PASS_THRESHOLD = 0.5;

export function deriveAssertionPassed(result: {
  readonly score: number;
  readonly passThreshold?: number;
  readonly errored?: true;
}): boolean {
  if (result.errored === true) return false;
  const threshold = result.passThreshold ?? DEFAULT_ASSERTION_PASS_THRESHOLD;
  return result.score >= threshold;
}

export interface AssertionResultProvenance {
  readonly nodeId: NodeId;
  readonly iterationId?: string;
  readonly itemIndex?: number;
}
